

















import {Vue, Component, Watch, Prop} from 'vue-property-decorator';
import ForceGraphBottom from './force-graph-bottom.vue';
import ForceGraphBtn from './force-graph-btn.vue';
import ForceGraphTop from './force-graph-top.vue';
import BrainSearch from './brain-search.vue';

@Component({
    components: {ForceGraphBottom, ForceGraphBtn, ForceGraphTop, BrainSearch}
})
export default class ForceGraphControl extends Vue {

}
